import IntranetLayout from "@/components/IntranetLayout";
import ModuleHeader from "@/components/voff/ModuleHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { Sparkles, CheckCircle2, AlertTriangle, XCircle } from "lucide-react";
import { toast } from "sonner";

const AUDITS = [
  { type: "ExxonMobil OVID Refresh", date: "2026-04-30", auditor: "OVID Inspector — Houston", readiness: 78, status: "Active" },
  { type: "ABS Annual Survey — Vanguard", date: "2026-08-12", auditor: "ABS Houston", readiness: 92, status: "Scheduled" },
  { type: "Azule Energy HSSE Prequal", date: "2026-05-22", auditor: "Azule HSE Lead", readiness: 64, status: "Active" },
  { type: "ABS DP Annual Trial — Paladio", date: "2026-06-22", auditor: "ABS Singapore", readiness: 88, status: "Scheduled" },
];

const EVIDENCE = [
  { req: "ISM SMC certificate", status: "OK", doc: "SMS-001-CERT" },
  { req: "DOC certificate", status: "OK", doc: "DOC-2024" },
  { req: "P&I insurance certificate", status: "OK", doc: "INS-PI-2026" },
  { req: "OVID 2025 assessment", status: "EXPIRED", doc: "OVID-2025 (expired Mar)" },
  { req: "SEMS II crew orientation records", status: "MISSING", doc: "—" },
  { req: "DP trial reports (12mo)", status: "OK", doc: "DPT-2025-Q4" },
  { req: "Last 3 incident investigations", status: "OK", doc: "INV-2025-x3" },
  { req: "Subcontractor approval list", status: "PARTIAL", doc: "SUB-LIST-2026 (incomplete)" },
];

const tone = (s: string) => s === "OK" ? "bg-[#2CA048]" : s === "PARTIAL" ? "bg-[#E8A020]" : s === "EXPIRED" ? "bg-[#E8A020]" : "bg-[#C83228]";

const AuditPrep = () => (
  <IntranetLayout>
    <ModuleHeader title="Audit Prep" subtitle="Pre-Audit Evidence Mapping & Gap Analysis"
      stats={[{ label: "Upcoming", value: 4 }, { label: "Avg readiness", value: "81%", tone: "good" }]} />

    <Card className="border-[#D0DDE6] mb-6"><CardContent className="p-5">
      <h3 className="font-bold text-[#00283C] mb-3">Audit Pipeline</h3>
      <div className="grid md:grid-cols-4 gap-3">{AUDITS.map(a => (
        <div key={a.type} className="border border-[#D0DDE6] rounded-lg p-3">
          <div className="text-xs text-[#6B8A9A]">{a.date}</div>
          <div className="font-bold text-sm text-[#00283C] mt-0.5">{a.type}</div>
          <div className="text-xs text-[#6B8A9A] mt-1">{a.auditor}</div>
          <div className="flex justify-between text-xs mt-2"><span>Readiness</span><span className="font-bold">{a.readiness}%</span></div>
          <Progress value={a.readiness} className="h-1.5 mt-1" />
          <Badge variant="outline" className="mt-2 text-[10px]">{a.status}</Badge>
        </div>
      ))}</div>
    </CardContent></Card>

    <Card className="border-[#D0DDE6]"><CardContent className="p-5">
      <div className="flex justify-between items-center mb-3">
        <h3 className="font-bold text-[#00283C]">Evidence Mapping — ExxonMobil OVID Refresh (30 Apr)</h3>
        <Button onClick={() => toast.success("Action recorded: Build Evidence Pack")} size="sm" className="bg-[#288CC8] text-white"><Sparkles className="w-3 h-3 mr-1" />Build Evidence Pack</Button>
      </div>
      <table className="w-full text-sm"><thead><tr className="border-b text-xs uppercase text-[#6B8A9A]"><th className="py-2 text-left">Requirement</th><th>Status</th><th className="text-left">Evidence on File</th><th></th></tr></thead>
        <tbody>{EVIDENCE.map(e => (
          <tr key={e.req} className="border-b border-[#D0DDE6]/50">
            <td className="py-2 font-medium">{e.req}</td>
            <td><Badge className={`${tone(e.status)} text-white text-[10px]`}>{e.status}</Badge></td>
            <td className="text-xs font-mono">{e.doc}</td>
            <td>{e.status === "MISSING" ? <XCircle className="w-4 h-4 text-[#C83228]" /> : e.status === "OK" ? <CheckCircle2 className="w-4 h-4 text-[#2CA048]" /> : <AlertTriangle className="w-4 h-4 text-[#E8A020]" />}</td>
          </tr>
        ))}</tbody>
      </table>
      <div className="bg-[#F4F7FA] p-3 rounded mt-4 text-xs text-[#0D1E2B]">
        <div className="font-bold text-[#00283C] mb-1">Pre-Audit Gap Report:</div>
        2 critical gaps before 30 April: (1) SEMS II crew orientation — schedule via ExxonMobil portal this week; (2) OVID 2026 — appointment booked, expected closure 26 April. Subcontractor list completion in progress with Procurement.
      </div>
    </CardContent></Card>
  </IntranetLayout>
);
export default AuditPrep;
